<template>
  <AppContainer class="introduction-section">
    <AppCard>
      <TextEditorInput
        id="executive-summary"
        v-model="planStore.executiveSummary"
        recommended-word-count="500"
        label="Executive Summary"
        :word-limit="600"
      />

      <TextEditorInput
        id="introduction"
        v-model="planStore.introduction"
        recommended-word-count="250 - 350"
        label="Introduction"
        :word-limit="500"
      />
    </AppCard>
  </AppContainer>
</template>

<script setup>
import { AppContainer } from '@/components/app/index.js';
import { TextEditorInput } from '@/components/form-inputs/index.js';

import { usePlanStore } from '@/store/index.js';
import { AppCard } from '@/components/cards/index.js';

const planStore = usePlanStore();
</script>
